import '../App.css';

function Contact() {
  return (
    <header className="App-header relative">
      <div className="container mx-auto px-4">
        <h1>Contact</h1>
        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-lg max-w-2xl mx-auto mt-8 border border-white/20">
          <div className="text-xl space-y-6 text-center">
            <div className="space-y-4">
              <p className="flex flex-col items-center gap-3">
                <a href="tel:+19023681234" className="hover:text-blue-300 transition-colors">
                  1-506-609-7866
                </a>
              </p>
              <p className="flex flex-col items-center gap-3">
                <span>Halifax, NS</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Contact; 